var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkModeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9988 18.5684C17.1263 18.8831 16.1793 19.0555 15.1897 19.0555C10.8405 19.0555 7.31473 15.7256 7.31473 11.6181C7.31473 7.51046 10.8405 4.18059 15.1897 4.18059C16.4989 4.18059 17.7334 4.48231 18.8197 5.01614C17.2206 3.73579 15.1905 3.01759 13.0779 3.00032C10.7045 2.98092 8.41913 3.84773 6.71919 5.41207C5.01926 6.97641 4.04243 9.11161 4.00135 11.3529C3.96027 13.5941 4.85826 15.76 6.49984 17.379C8.14142 18.9979 10.3937 19.9389 12.7663 19.9971C14.6369 20.043 16.4628 19.5373 17.9988 18.5684Z",
    fill: "#ADADAD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeIcon);
export default __webpack_public_path__ + "static/media/dark-mode-icon.8bdac65c4623336ce668a6cc2828caba.svg";
export { ForwardRef as ReactComponent };